module.exports = __webpack_public_path__ + "img/icrproduction.5c68d410.jpg";